import { addBusinessDays as addBD } from 'date-fns';

export function formatUpdatedAt(dateString: string): string {
	const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
	const date = new Date(dateString);

	return date.toLocaleDateString('en-US', options);
}

// *mutates* the date
export function addDays(date: Date, days: number): Date {
	date.setDate(date.getDate() + days);

	return date;
}

export function addBusinessDays(date: Date, days: number): Date {
	return addBD(date, days);
}
